var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"logo","d":"M17.619,4.644h2.553V.2a32.97,32.97,0,0,0-3.72-.2c-3.681,0-6.2,2.316-6.2,6.571v3.917H6.187v4.971h4.062V27.968H15.23V15.46h3.9l.619-4.971H15.229V7.064c0-1.437.388-2.42,2.39-2.42Z","transform":"translate(-6.187 0)","fill":"#14171c"}));
}

Facebook.defaultProps = {"id":"Group_33","data-name":"Group 33","width":"13.985","height":"27.968","viewBox":"0 0 13.985 27.968"};

module.exports = Facebook;

Facebook.default = Facebook;
